/** 与 stats-app H5 web-view 壳层同步地址栏 */

export const STATS_H5_ROUTE_SYNC = 'STATS_H5_ROUTE_SYNC'

export function isInStatsH5Shell() {
  try {
    return typeof window !== 'undefined' && window.self !== window.top
  } catch (e) {
    return true
  }
}

function toSyncUrl(fullUrl) {
  try {
    const u = new URL(fullUrl)
    u.searchParams.delete('ticket')
    u.searchParams.delete('device_id')
    return `${u.origin}${u.pathname}${u.search}${u.hash}`
  } catch (e) {
    return fullUrl
  }
}

/**
 * 通知父页（stats-app）把地址栏更新为当前 H5 页，不刷新 webview
 * @param {string} fullUrl 当前 H5 完整 URL
 */
export function syncStatsShellRoute(fullUrl) {
  if (!isInStatsH5Shell() || !fullUrl) return
  const h5Url = (process.env.VUE_APP_H5_URL || '').trim()
  if (!h5Url) return

  try {
    window.parent.postMessage(
      {
        type: STATS_H5_ROUTE_SYNC,
        url: toSyncUrl(fullUrl),
      },
      '*'
    )
  } catch (e) {
    // ignore
  }
}

/** 在 Vue Router 上挂载：进入 view 壳后，所有路由变化都同步父页地址栏 */
export function installStatsShellRouteSync(router) {
  const syncNow = () => {
    if (!isInStatsH5Shell()) return
    const href = window.location.href.split('#')[0]
    syncStatsShellRoute(href)
  }

  router.afterEach(() => {
    // 等 history 落盘后再同步
    setTimeout(syncNow, 0)
  })

  if (typeof window !== 'undefined') {
    if (document.readyState === 'complete') {
      syncNow()
    } else {
      window.addEventListener('load', syncNow, { once: true })
    }
  }
}
